<template>
  <el-container class="f-h" style="display: flex; justify-content: center">
    <el-empty v-if="errMsg" :description="errMsg" />
    <hic-emr-info-panel v-else :op-no="opNo" />
  </el-container>
</template>

<script>
  import { mapGetters } from "sw-hic";
  import api from "@/common/api";
  export default {
    data() {
      return {
        loading: false,
        errMsg: null,
        opNo: null,
      };
    },
    computed: {
      ...mapGetters(["token"]),
    },
    mounted() {
      if (!this.token) {
        this.showErr("当前用户尚未登录！");
        return;
      }
      this.init();
    },
    methods: {
      async init() {
        this.errMsg = null;
        if (this.$route.query.op) {
          this.opNo = this.$route.query.op;
        } else if (this.$route.query.patient) {
          api.Treatment.query({
            patientCode: this.$route.query.patient,
            sort: "id",
            asc: false,
            pageSize: 1,
            pageIndexOnView: 1,
          })
            .then((res) => {
              if (res.items && res.items.length) {
                this.opNo = res.items[0].opNo;
              } else {
                this.showErr("缺少就诊号！");
              }
            })
            .catch((err) => {
              this.showErr("获取就诊号时发生异常！");
              console.log(err);
            });
        } else {
          this.showErr("缺少就诊号、患者ID！");
        }
      },
      showErr(err) {
        this.$message.error(err);
        this.errMsg = err;
      },
    },
  };
</script>
